<div class="mt-60">
  <div *ngIf="!isLoggedIn" class="max-w-4xl mx-auto px-4">
    <div *ngIf="isTokenPresent" class="flex justify-center items-center">
      <div
        class="w-12 h-12 border-4 border-blue-500 border-dashed rounded-full animate-spin"
      ></div>
    </div>

    <h4 *ngIf="!isTokenPresent" class="text-lg text-gray-700 mt-6">
      You are not logged in. Click
      <a
        (click)="login()"
        routerLinkActive="active"
        class="text-blue-600 hover:underline cursor-pointer"
        >here</a
      >
      to login.
    </h4>

    <h4 *ngIf="!isTokenPresent" class="text-lg mt-4">
      If you see this page even after logging in, you are not authorized to view
      this app. Kindly contact the administrator!
    </h4>
  </div>
</div>
